const defaultSettings = require('../settings')
// 本地环境配置
module.exports = {
  title: defaultSettings.title || 'xxh-zhaopin-web',
  port: 9018, // 端口
  baseFileUrl: 'https://devin-gw.DOMAIN_NAME', // 文件服务
  baseUrl: 'https://devcustomer.DOMAIN_NAME', // 项目地址
  // baseApi: 'http://192.168.7.231:9090' // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  baseApi: 'https://preportal.dhrforce.com',
  loginUrl: 'https://preportal.dhrforce.com',
  baseSiteCdn: 'https://sitecdn.71360.com',
  recruitPath: 'https://pre-ihire-app.dhrforce.com', // 招聘助手H5
}
